import React, { useState, useEffect } from 'react';
import './App.css';
import TalentMatrix from './components/TalentMatrix';
import Login from './components/Login';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const loggedIn = localStorage.getItem('isLoggedIn') === 'true';
    const savedUsername = localStorage.getItem('username');
    const savedRole = localStorage.getItem('userRole');
    
    if (loggedIn && savedUsername) {
      setIsLoggedIn(true);
      setUser({
        username: savedUsername,
        role: savedRole
      });
    }
  }, []);

  const handleLogin = (userData) => {
    setIsLoggedIn(true);
    setUser(userData);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUser(null);
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('username');
    localStorage.removeItem('userRole');
  };

  if (!isLoggedIn) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <div className="App">
      <header className="App-header">
        <div className="header-content">
          <div className="logo">
            <img src="/assets/logo.png" alt="Logo" />
          </div>
          <div className="header-text">
            <h1>人才盘点系统</h1>
            <div className="header-subtitle">
              <span className="subtitle-item">科学评估</span>
              <span className="subtitle-dot">·</span>
              <span className="subtitle-item">精准盘点</span>
              <span className="subtitle-dot">·</span>
              <span className="subtitle-item">高效发展</span>
            </div>
          </div>
          <div className="user-info">
            <span>{user?.username}</span>
            <span className="user-role">({user?.role === 'admin' ? '管理员' : '用户'})</span>
            <button onClick={handleLogout} className="logout-button">
              退出
            </button>
          </div>
        </div>
      </header>
      <main>
        <div className="page-container">
          <div className="breadcrumb">
            <span className="breadcrumb-item">首页</span>
            <span className="breadcrumb-separator">/</span>
            <span className="breadcrumb-item active">人才矩阵</span>
          </div>
          <TalentMatrix />
        </div>
      </main>
      <footer className="App-footer">
        <div className="footer-content">
          <p>© {new Date().getFullYear()} 人才盘点系统 - 助力企业人才发展</p>
        </div>
      </footer>
    </div>
  );
}

export default App; 